import React from "react";
const tableHead = [
  "Sr.",
  "Employee Name",
  "task Completion Percentage",
  "attendance Percentage",
];

const ViewEEP = ({ data = [], currentPage, itemsPerPage }) => {
  const sortedData = data.sort((a, b) => {
    return (
      b.taskCompletionPercentage - a.taskCompletionPercentage ||
      b.attendancePercentage - a.attendancePercentage
    );
  });

  const returnClassnameBg = (item) => {
    if (
      +item.taskCompletionPercentage >= 90 &&
      +item.attendancePercentage >= 90
    ) {
      return { backgroundColor: "rgba(144, 238, 144, 0.2)" };
    } else if (
      +item.taskCompletionPercentage >= 90 ||
      +item.attendancePercentage >= 90
    ) {
      return { backgroundColor: "rgba(255, 255, 102, 0.2)" };
    } else {
      return { backgroundColor: "rgba(255, 99, 71, 0.2)" };
    }
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {sortedData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id} style={returnClassnameBg(item)}>
                <td>{Index}</td>
                <td>{item?.userName}</td>
                <td>
                  <img
                    src="https://res.cloudinary.com/dezupfsqo/image/upload/v1737435786/dayStreakFireIcon_jtmz2c.png"
                    alt="points"
                    className="me-1 ms-1"
                    width={20}
                  />
                  {Math.min(item?.taskCompletionPercentage, 100)}%
                </td>
                <td>
                  <img
                    src="https://res.cloudinary.com/dezupfsqo/image/upload/v1737435786/dayStreakFireIcon_jtmz2c.png"
                    alt="points"
                    className="me-1 ms-1"
                    width={20}
                  />
                  {item?.attendancePercentage}%
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ViewEEP;
